import type { RouteRecordRaw } from 'vue-router';

const DestinataryInvite = () =>
  import('@/modules/contacts/pages/DestinataryInvite/index.vue');

export const contactsPublicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/p/destinatario',
    name: 'destinatary-public',
    children: [
      {
        path: 'invitar',
        name: 'destinatary-invite',
        component: DestinataryInvite,
      },
    ],
  },
];
